import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { Container } from './styled';

const messages = defineMessages({
	label: {
		defaultMessage: 'Recommended',
		description: 'The default label to show that an option is recommended',
		id: 'selectList.card.recommendedLabel',
	},
});

type RecommendedBadgeProps = {
	isSelected: boolean;
	testId?: string;
};

export const RecommendedBadge = ({
	testId,
	isSelected = false,
}: RecommendedBadgeProps): React.JSX.Element => {
	const intl = useIntl();

	return (
		<Container data-testid={testId} isSelected={isSelected}>
			{intl.formatMessage(messages.label)}
		</Container>
	);
};
